import {
    getLocationFromAssetMappings,
    getNodeId, isResponseCode5xx,
    logOperationalMetric
} from "../../../util/Util";
import {
    ACTIVE, LIDAR_ASSET_TYPE, LOADING_FAILED
} from "../../../util/Constants";
import {getAssets, getAssetByAssetLabel, getAssetsConnectivity} from "../../../resources/AssetResource";

export const metricProcessName = "LIDAR_DEVICE_DETAILS";

export function fetchLidarDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: LIDAR_ASSET_TYPE
    }
    getLidarDeviceDetails(dispatcher, request)
}

export const extractLidarDeviceList = (result, lidarLocations, lidarConnectivity) => {
    const model = {
        lidarDeviceInformation: {}
    }
    const lidarConnectivityMap = {}
    if (lidarConnectivity.data && lidarConnectivity.data.assetConnectivityList) {
        lidarConnectivity.data.assetConnectivityList.forEach(connectivity => {
            lidarConnectivityMap[connectivity.identifier] = connectivity;
        })
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((lidarDeviceDetail) => {
            if (lidarDeviceDetail.assetStatus === ACTIVE) {
                const detail = lidarConnectivityMap[lidarDeviceDetail.assetAttributes.ControllerIP];
                model.lidarDeviceInformation[lidarDeviceDetail.assetLabel.value] = {
                    mac: lidarDeviceDetail.assetLabel.value,
                    ip: lidarDeviceDetail.assetAttributes.ControllerIP,
                    connectivity: detail ? detail.status : LOADING_FAILED,
                    timestamp: detail ? detail.lastUpdateTime : "",
                    location: lidarLocations[lidarDeviceDetail.assetLabel.value] ? lidarLocations[lidarDeviceDetail.assetLabel.value] : "Not Configured"
                }
            }
        });
    }
    return model;
}

async function getLidarLocations(result) {
    const startTime = Date.now();
    const macToClusterLabelMap = {};
    const promises = [];
    if(result.data && result.data.assetDetailsList) {
        result.data.assetDetailsList.forEach((lidarDeviceDetail) => {
            if (lidarDeviceDetail.assetLabel) {
                promises.push(getAssetByAssetLabel(lidarDeviceDetail.assetLabel))
            }
        });
    }
    const results = await Promise.all(promises);
    results.forEach((res, index) => {
        processResult(res, index, result, macToClusterLabelMap, startTime);
    });
    return macToClusterLabelMap;
}

function processResult(res, index, result, macToClusterLabelMap, startTime) {
    if (res.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLidarLocations", true, false);
        const assetMappings = res.data.asset.assetMappings;
        if (assetMappings.length > 0) {
            const mac = result.data.assetDetailsList[index].assetLabel.value;
            macToClusterLabelMap[mac] = getLocationFromAssetMappings(assetMappings);
        }
    } else {
        const isFault = isResponseCode5xx(res.status)
        logOperationalMetric(startTime, metricProcessName, "getLidarLocations", false, isFault);
    }
}

async function getLidarDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    const deviceIdentifierList = [];
    let lidarConnectivity = {};
    const result = await getAssets(request.nodeId, request.assetType);
    if (result.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLidarDeviceDetails", true, false);
        const lidarLocations = await getLidarLocations(result);
        result.data.assetDetailsList.forEach(assetDetail => {
            deviceIdentifierList.push(assetDetail.assetAttributes.ControllerIP);
        })

        if (deviceIdentifierList && deviceIdentifierList.length > 0) {
            lidarConnectivity = await getAssetsConnectivity(request.nodeId, request.assetType, deviceIdentifierList);
        }
        const model = extractLidarDeviceList(result, lidarLocations, lidarConnectivity);
        dispatcher({type: "RECEIVE_DATA", data: model});
    } else {
        const isFault = isResponseCode5xx(result.status)
        logOperationalMetric(startTime, metricProcessName, "getLidarDeviceDetails", false, isFault);
        dispatcher({type: "RECEIVE_DATA", data: []});
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/network/LidarOverviewNetworkAPI.js